module.exports = __webpack_public_path__ + "img/carita_blanca.df085523.png";